import { useEffect, useState } from 'react';
const { DateTime } = require("luxon");

const useCountdown = (targetDate) => {
  const countDownDate = targetDate

  const [countDown, setCountDown] = useState(
    countDownDate - DateTime.utc()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - DateTime.utc());
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return getReturnValues(countDown);
};

const getReturnValues = (countDown) => {
  // calculate time left
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return [countDown, days, hours, minutes, seconds];
};

export { useCountdown };